export default { millisecondsPerSecond: 1000 };
